module.exports = __webpack_public_path__ + "components/advertise-markets/static/guest-9a838543e958867a3152547f94a3177f.jpg";